'use client';

import {
  useReactRouterSyncWithUrlParam,
  useReactRouterUpdateSearchParams,
} from './useReactRouterSyncWithUrlParam';

export function useReactRouterSorting<Value extends string | undefined>({
  defaultSortDirection,
  defaultSortValue,
  tableId,
}: {
  defaultSortDirection: 'asc' | 'desc';
  defaultSortValue: Value;
  tableId?: string;
}) {
  const [sortBy, setSortBy] = useReactRouterSyncWithUrlParam<Value>({
    defaultValue: defaultSortValue,
    getInitialValue: (paramValue) => (paramValue || defaultSortValue) as Value,
    paramKey: `sortBy${tableId ? `-${tableId}` : ''}`,
  });
  const [sortOrder, setSortOrder] = useReactRouterSyncWithUrlParam<'asc' | 'desc'>({
    defaultValue: defaultSortDirection,
    paramKey: `sortOrder${tableId ? `-${tableId}` : ''}`,
    parseParamValue: handleSortOrderValue,
  });

  const updateSearchParams = useReactRouterUpdateSearchParams();

  const handleChangeSort = (property: Value) => {
    const isAsc = sortBy === property && sortOrder === 'asc';
    updateSearchParams({
      ...setSortOrder(isAsc ? 'desc' : 'asc', true),
      ...setSortBy(property, true),
    });
  };

  return { handleChangeSort, setSortBy, setSortOrder, sortBy, sortOrder };
}

function handleSortOrderValue(paramValue: string) {
  if (paramValue === 'asc' || paramValue === 'desc') {
    return paramValue;
  }

  return 'desc';
}
